"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_PAYMENT_METHOD_SOURCES = void 0;
var USER_PAYMENT_METHOD_SOURCES = exports.USER_PAYMENT_METHOD_SOURCES = ['CASH', 'PERSONAL', 'CORPORATE'];